import React from 'react';
import PropTypes from 'prop-types';

class Mine extends React.Component {
    render() {
        const { mine } = this.props;
        return (
            <div className="submenu__row mine-selection">
                <ul className="menu">
                    <li className="menu__item" key={`mine-${mine.id}`}>
                        <span className="label description">{mine.description}</span>
                        <div className="mine">
                            <img src={mine.image} alt={mine.name} />
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
}

Mine.propTypes = {
    mine: PropTypes.object.isRequired,
};

Mine.defaultProps = {};

export default Mine;
